import { trans } from '@/helpers/trans'
import { CardColor } from '@/types'

import { StatusForCurrentUser } from './ts/Shift'
import { UserResource } from './User'

interface ShiftStatusType {
    label: string
    color: CardColor
    icon?: string
}

export interface ShiftWithStatus {
    statusForCurrentUser?: StatusForCurrentUser | string
    registeredUsers?: UserResource[]
}

// The label, color and icon that belong to the status a shift has for the current user
export class ShiftStatus {
    shiftTypes: Record<string, ShiftStatusType> = {
        open: { label: trans('common.open'), color: CardColor.secondary },
        absent: { label: trans('common.absence'), color: CardColor.danger },
        registered: { label: trans('common.signedUp'), color: CardColor.orange },
        registeredToOffer: { label: trans('common.signedUp'), color: CardColor.orange },
        planned: { label: trans('common.planned'), color: CardColor.success },
        offeredByMe: { label: trans('common.planned'), icon: 'swap_horiz', color: CardColor.success },
        offered: { label: trans('pages.shifts.shiftToExchange'), color: CardColor.secondary },
        full: { label: trans('common.full'), color: CardColor.orange },
    }

    shift: ShiftWithStatus

    constructor(shift: ShiftWithStatus) {
        this.shift = shift
    }

    getStatus(): string | undefined {
        return this.shift.statusForCurrentUser
    }

    getType(): Partial<ShiftStatusType> {
        const status = this.getStatus()

        return (status && this.shiftTypes[status]) || {}
    }

    getLabel(): string | undefined {
        return this.getType().label
    }

    getColor(): CardColor | undefined {
        return this.getType().color
    }

    getIcon(): string | null {
        return this.getType().icon || null
    }

    getRegisteredUsers(): UserResource[] | undefined | false {
        if (this.getStatus() === 'offeredByMe') {
            return this.shift.registeredUsers
        }

        return false
    }
}
